import React, { useState, useEffect } from "react";
import Header from "./Header";
import Hero from "./Hero";
import WelcomeGate from "./WelcomeGate";
import Yahffirmations from "./Yahffirmations";
import About from "./About";
import Storyteller from "./Storyteller";
import Skills from "./Skills";
import Experience from "./Experience";
import SeedsOfWisdom from "./SeedsOfWisdom";
import Projects from "./Projects";
import Blog from "./Blog";
import Resources from "./Resources";
import Contact from "./Contact";
import Footer from "./Footer";
import { FEATURES } from "../config/features";

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "about", "storyteller", "skills", "experience", "projects", "blog", "resources", "contact"];
      const scrollPosition = window.scrollY + 100;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-white text-black font-light">
      {/* Welcome Gate - Shows on first visit only */}
      <WelcomeGate />
      
      <Header activeSection={activeSection} scrollToSection={scrollToSection} />
      
      <main>
        <section id="home">
          <Hero />
        </section>
        
        <section id="about" className="py-24">
          <About />
        </section>
        
        <section id="storyteller">
          <Storyteller />
        </section>
        
        <section id="skills" className="py-24 bg-gray-50">
          <Skills />
        </section>
        
        <section id="experience" className="py-24">
          <Experience />
        </section>
        
        {/* Seeds of Wisdom Video Section - NEW */}
        <SeedsOfWisdom />
        
        <section id="projects" className="py-24 bg-gray-50">
          <Projects />
        </section>
        
        <section id="yahffirmations">
          <Yahffirmations />
        </section>
        
        <section id="blog">
          <Blog />
        </section>
        
        {FEATURES.showAllFeatures && (
        <section id="resources">
          <Resources />
        </section>
        )}
        
        <section id="contact" className="py-24">
          <Contact />
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Portfolio;